module.exports = __webpack_public_path__ + "349f3499446e2300a7f7a4d8e69c5423.png";